import {HttpClient} from "../../service/httpClient/HttpClient";

export class CampaignsService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getCampaignsList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `location-registration-campaigns`,
                {page, size}
            ).then(resolve).catch(reject)
        })
    }

    createNewCampaign(title, slug, starDate, endDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `location-registration-campaigns`,
                {
                    title,
                    slug,
                    starDate,
                    endDate
                }
            ).then(resolve).catch(reject)
        })
    }


    getCampaignBasicInfo(campaignId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `location-registration-campaigns/${campaignId}`
            ).then(resolve).catch(reject)
        })
    }

    updateCampaignBasicInfo(campaignId, title, slug, description, rules) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `location-registration-campaigns/${campaignId}`,
                {},
                {
                    "title": title,
                    "slug": slug,
                    "description": description,
                    "rules": rules
                }
            ).then(resolve).catch(reject)
        })
    }

    getCampaignPeriod(campaignId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `location-registration-campaigns/${campaignId}/periods`
            ).then(resolve).catch(reject)
        })
    }

    updateCampaignPeriod(campaignId,startDate,endDate){
        return new Promise((resolve, reject)=>{
            this.httpClient.patch(
                `location-registration-campaigns/${campaignId}/periods`,
                {},
                {
                    "from":startDate,
                    "to":endDate,
                }
            ).then(resolve).catch(reject)
        })
    }
    getAdmissionSettings(campaignId){

        return new Promise((resolve, reject)=>{
            this.httpClient.get(
                `location-registration-campaigns/${campaignId}/admission-settings`,

            ).then(resolve).catch(reject)
        })
    }

    updateAdmissionSettings(campaignId,automaticAcceptance,acceptance,enabled,maximumNumberOfRegistrationsAllowed){
        return new Promise((resolve, reject)=>{
            this.httpClient.patch(
                `location-registration-campaigns/${campaignId}/admission-settings`,
                {},
                {
                    "automaticAcceptance":automaticAcceptance,
                    "acceptance":acceptance,
                    "enabled":enabled,
                    "maximumNumberOfRegistrationsAllowed":maximumNumberOfRegistrationsAllowed
                }
            ).then(resolve).catch(reject)
        })
    }
}